<div class="forward-announcement-company">
    <p class="forward-announcement-company--label">Empresa Pagadora</p>
    <p class="forward-announcement-company--name">{{mainInvoice?.debtor?.companyName}}</p>
</div>
<app-invoice-announcement-confirmation-table [invoices]="entity?.invoices">
</app-invoice-announcement-confirmation-table>
<app-new-announcement-card
  [announcement]="entity?.announcementDetail"
  [showActions]="false"
>
</app-new-announcement-card>
<div class="forward-announcement-finalized-card" *ngIf="mainInvoice?.status === 'finalized'">
  <lib-icon icon="info" size="s" color="red"></lib-icon>
  <div class="forward-announcement-finalized-card-content">
    <p>Seleccionaste algunas facturas finalizadas</p>
    <span>
      Recuerda que estas comunicaciones deben ser bien puntuales y validadas con el líder comercial.
    </span>
  </div>
</div>